export default {
  // Layout section dnd actions
  MODULE_EDITOR_ADDED: 'MODULE_EDITOR_ADDED',
  LAYOUT_SECTION_DRAGGING_STARTED: 'LAYOUT_SECTION_DRAGGING_STARTED',
  LAYOUT_SECTION_DRAGGING_STOPPED: 'LAYOUT_SECTION_DRAGGING_STOPPED',
  LAYOUT_SECTION_DROP_COORDS_UPDATED: 'LAYOUT_SECTION_DROP_COORDS_UPDATED',
  LAYOUT_SECTION_HOVER_POSITIONS_CLEARED: 'LAYOUT_SECTION_HOVER_POSITIONS_CLEARED',
  LAYOUT_SECTION_HOVER_POSITIONS_UPDATED: 'LAYOUT_SECTION_HOVER_POSITIONS_UPDATED',
  LAYOUT_SECTION_NODE_POSITIONS_UPDATED: 'LAYOUT_SECTION_NODE_POSITIONS_UPDATED',
  LAYOUT_SECTION_NODE_POSITIONS_CLEARED: 'LAYOUT_SECTION_NODE_POSITIONS_CLEARED',
  LAYOUT_SECTION_NODE_POSITIONS_REFRESHED_BUT_UNCHANGED: 'LAYOUT_SECTION_NODE_POSITIONS_REFRESHED_BUT_UNCHANGED',
  LAYOUT_SECTION_HOVERED_DRAG_HANDLE_UPDATED: 'LAYOUT_SECTION_HOVERED_DRAG_HANDLE_UPDATED',
  LAYOUT_SECTION_DRAG_HANDLES_BLURRED: 'LAYOUT_SECTION_DRAG_HANDLES_BLURRED',
  LAYOUT_SECTION_DRAG_ITEM_IS_HIDDEN_UPDATED: 'LAYOUT_SECTION_DRAG_ITEM_IS_HIDDEN_UPDATED',
  LAYOUT_SECTION_MOUSE_ENTERED_IFRAME: 'LAYOUT_SECTION_MOUSE_ENTERED_IFRAME',
  LAYOUT_SECTION_MOUSE_LEFT_IFRAME: 'LAYOUT_SECTION_MOUSE_LEFT_IFRAME',
  LAYOUT_SECTION_SCROLL_POSITION_CHANGED: 'LAYOUT_SECTION_SCROLL_POSITION_CHANGED',
  LAYOUT_SECTION_TOOLBAR_MEASURED: 'LAYOUT_SECTION_TOOLBAR_MEASURED',
  LAYOUT_SECTION_HOVER_POSITIONS_FROZEN: 'LAYOUT_SECTION_HOVER_POSITIONS_FROZEN',
  LAYOUT_SECTION_HOVER_POSITIONS_THAWED: 'LAYOUT_SECTION_HOVER_POSITIONS_THAWED'
};